import React from "react";
import { Row, Col, Typography, Space, Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import testimonial from "../../assets/images/testimonial.svg";

const { Title, Text, Paragraph } = Typography;

const Testimonial = () => {
  return (
    <div
      style={{
        padding: "80px 20px",
        background: "#fff",
      }}
    >
      <Row
        gutter={[48, 48]}
        align="middle"
        justify="center"
        style={{ maxWidth: 1100, margin: "0 auto" }}
      >
        {/* LEFT IMAGE */}
        <Col xs={24} md={10} style={{ textAlign: "center" }}>
          <img
            src={testimonial}
            alt="testimonial"
            style={{
              width: "100%",
              maxWidth: 320,
              borderRadius: 12,
            }}
          />
        </Col>

        {/* RIGHT CONTENT */}
        <Col xs={24} md={14}>
          <Space direction="vertical" size={24} style={{ width: "100%" }}>
            {/* Quote Icon */}
            <Text
              style={{
                fontSize: 48,
                color: "#6d28d9",
                lineHeight: 1,
                fontWeight: 700,
              }}
            >
              “
            </Text>

            {/* Main Quote */}
            <Paragraph
              style={{
                fontSize: 30,
                lineHeight: 1.3,
                fontWeight: 500,
                margin: 0,
                maxWidth: 720,
                color: "#2d1e6b",
              }}
            >
              We honestly reference Hostinger as the{" "}
              <span style={{ color: "#673DE6" }}>benchmark</span> for our
              engineers when providing
              <span style={{ color: "#673DE6" }}> support.</span>
            </Paragraph>

            {/* Link */}
            <Button
              type="link"
              style={{
                padding: 0,
                color: "#6d28d9",
                fontWeight: 500,
              }}
            >
              Read the full story
            </Button>

            {/* Author */}
            <div>
              <Text strong style={{ fontSize: 15, color: "#2d1e6b" }}>
                Charlie Low & Dale Comley
              </Text>
              <br />
              <Text type="secondary" style={{ fontSize: 14, color: "#2d1e6b" }}>
                Co-founders of Nohma | nohna.com
              </Text>
            </div>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default Testimonial;
